import React from 'react';
import { Layout } from 'fronton-react';
import { Remote } from '@okapi/remote';
import { SeoDescriptionSection } from 'features/seo-description';
import { AnalyticsPageMeta } from 'features/analytics';
import { HistoryCarousel } from 'common/components/history-carousel';
import { useSelector } from 'react-redux';
import { getPathname, getRegionId } from 'features/page-model/ducks/get-model';
import { getIsAuthorized, getEnv } from 'common/selectors';
import { historyItems } from 'common/data';
import { useGaPageview } from 'features/analytics/hooks';
import { CardsSection } from '../about-us/components/cards-section';
import { GreyBackground, RoundedLayout } from './styles';
import { RebrandSection } from './components/rebrand-section';
import { NewLemana } from './components/new-lemana';

export const Rebranding: React.FC = () => {
  const path = useSelector(getPathname);
  const isAuthorized = useSelector(getIsAuthorized) ? '1' : '0';
  const regionId = useSelector(getRegionId);
  const { USE_APPSFLYER } = useSelector(getEnv);

  useGaPageview(path, isAuthorized, regionId);
  return (
    <>
      <AnalyticsPageMeta />
      <Remote widget="header-footer/header" id="about-header" data={{ disableAppsflyer: !USE_APPSFLYER }} />
      <RebrandSection />
      <GreyBackground>
        <RoundedLayout>
          <Layout>
            <NewLemana />
          </Layout>
        </RoundedLayout>
      </GreyBackground>
      <CardsSection />
      <HistoryCarousel items={historyItems} />
      <Layout>
        <SeoDescriptionSection />
      </Layout>
      <Remote widget="header-footer/footer" id="about-footer" />
    </>
  );
};
